/**
 * @module common/classes/plugin
 */

/**
 * @hideconstructor
 * @classdesc Класс плагина
 */
class Plugin {
  /**
   * @method
   * @abstract
   * @static
   * @description Инициализация модуля
   */
  static init() {
    return Function.prototype;
  }
}
/**
 * @member {*} module:common/classes/plugin~Plugin.config
 * @abstract
 * @description Конфигурация модуля
 */
Plugin.config = {};

export default Plugin;
